import React from 'react';
import { AlertTriangleIcon, XCircleIcon, TrendingDownIcon, DollarSignIcon } from 'lucide-react';
import { AnimatedSection, AnimatedItem } from './AnimatedSection';
export function ProblemSection() {
  return <section className="w-full bg-navy-800" data-id="element-239">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 py-20 md:py-28" data-id="element-240">
        <AnimatedSection data-id="element-241">
          {/* Section header */}
          <AnimatedItem data-id="element-242">
            <div className="flex items-center gap-3 mb-4" data-id="element-243">
              <div className="h-px flex-1 max-w-[60px] bg-gold-500/40" data-id="element-244" />
              <span className="text-gold-400 text-xs font-body font-semibold tracking-[0.2em] uppercase" data-id="element-245">
                El Problema
              </span>
            </div>
          </AnimatedItem>

          <AnimatedItem data-id="element-246">
            <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold text-white leading-tight" data-id="element-247">
              El modelo de retiro tradicional{' '}
              <span className="text-gold-400" data-id="element-248">está roto.</span>
            </h2>
          </AnimatedItem>

          <AnimatedItem data-id="element-249">
            <p className="mt-6 text-base md:text-lg text-slate-300 font-body leading-relaxed max-w-3xl" data-id="element-250">
              Te han enseñado a acumular una montaña de dinero para luego
              gastarla poco a poco, rogando que no se acabe antes de que mueras.
            </p>
          </AnimatedItem>

          <AnimatedItem data-id="element-251">
            <p className="mt-4 text-base md:text-lg text-slate-300 font-body leading-relaxed max-w-3xl" data-id="element-252">
              Pero la realidad es cruel: la inflación devora tu poder
              adquisitivo, las crisis de mercado pueden borrar el 30% de tu
              patrimonio en una semana y el ahorro pasivo es demasiado lento
              para quienes desean disfrutar la vida{' '}
              <span className="text-white font-semibold" data-id="element-253">hoy</span>, no en 30
              años. Estás atrapado en la{' '}
              <span className="text-gold-300 italic" data-id="element-254">"esperanza"</span>, no en
              una estrategia.
            </p>
          </AnimatedItem>

          {/* Why what you tried didn't work */}
          <AnimatedItem data-id="element-255">
            <h3 className="font-display text-xl sm:text-2xl font-bold text-white mt-14 mb-8" data-id="element-256">
              ¿Por qué lo que has intentado no funciona?
            </h3>
          </AnimatedItem>

          <div className="space-y-5" data-id="element-257">
            <AnimatedItem data-id="element-258">
              <div className="flex items-start gap-4 p-5 rounded-xl bg-navy-700/60 border border-slate-700/40" data-id="element-259">
                <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-red-500/10 flex items-center justify-center mt-0.5" data-id="element-260">
                  <TrendingDownIcon className="w-5 h-5 text-red-400" aria-hidden="true" data-id="element-261" />
                </div>
                <p className="text-slate-300 font-body leading-relaxed" data-id="element-262">
                  <span className="text-white font-semibold" data-id="element-263">
                    Los fondos mutuos y 401k
                  </span>{' '}
                  crecen a un ritmo penoso y cobran comisiones incluso cuando tú
                  pierdes dinero.
                </p>
              </div>
            </AnimatedItem>

            <AnimatedItem data-id="element-264">
              <div className="flex items-start gap-4 p-5 rounded-xl bg-navy-700/60 border border-slate-700/40" data-id="element-265">
                <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-red-500/10 flex items-center justify-center mt-0.5" data-id="element-266">
                  <DollarSignIcon className="w-5 h-5 text-red-400" aria-hidden="true" data-id="element-267" />
                </div>
                <p className="text-slate-300 font-body leading-relaxed" data-id="element-268">
                  <span className="text-white font-semibold" data-id="element-269">
                    El ahorro en el banco
                  </span>{' '}
                  es una trampa de pobreza; con tasas de interés bajas, tu
                  dinero muere lentamente.
                </p>
              </div>
            </AnimatedItem>

            <AnimatedItem data-id="element-270">
              <div className="flex items-start gap-4 p-5 rounded-xl bg-navy-700/60 border border-slate-700/40" data-id="element-271">
                <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-red-500/10 flex items-center justify-center mt-0.5" data-id="element-272">
                  <AlertTriangleIcon className="w-5 h-5 text-red-400" aria-hidden="true" data-id="element-273" />
                </div>
                <p className="text-slate-300 font-body leading-relaxed" data-id="element-274">
                  <span className="text-white font-semibold" data-id="element-275">
                    El "trading" de criptomonedas o acciones especulativas
                  </span>{' '}
                  es una apuesta emocional que suele terminar en pérdida total
                  por falta de un método lógico.
                </p>
              </div>
            </AnimatedItem>
          </div>
        </AnimatedSection>
      </div>

      <div className="h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent" data-id="element-276" />
    </section>;
}